import React from "react";
import { useSelector } from "react-redux";
import { Wrapper } from "./declined.styles";
import cryFace from "../animatedGifs/tracker-sad-optimised.gif";
import { DECLINED_REASONS } from "../trackingConstants";

export const Declined = () => {
  const { declinedReason, firstName } = useSelector(
    (state) => state.trackingStatus.value
  );
  const { declinePageContent } = useSelector(
    (state) => state.StartUp.theme.configFile
  );

  let declinedReasonText = "";
  let declineReasonMeaning = "";
  let linkSuffix = "";

  switch (declinedReason) {
    case DECLINED_REASONS.AFFORDABILITY:
      declinedReasonText = " your affordability";
      declineReasonMeaning = "affordability";
      linkSuffix = "-affordability";
      break;
    case DECLINED_REASONS.BANK_ACCOUNT_CONDUCT:
      declinedReasonText = " your bank account conduct";
      declineReasonMeaning = "bank account conduct";
      linkSuffix = "-bank-account-conduct";
      break;
    case DECLINED_REASONS.CREDIT_HISTORY:
      declinedReasonText = " your credit history";
      declineReasonMeaning = "credit history";
      linkSuffix = "-history";
      break;
    case DECLINED_REASONS.EMPLOYMENT_STATUS:
      declinedReasonText = " your employment status";
      declineReasonMeaning = "employment status";
      linkSuffix = "-employment-status";
      break;
    case DECLINED_REASONS.COMBINATION_OF_REASONS:
      declinedReasonText = " a combination of reasons";
      declineReasonMeaning = "our lending criteria";
      linkSuffix = "-a-combination-of-reasons";
      break;
    case DECLINED_REASONS.RECENT_OR_PREVIOUS_CONDUCT:
      declinedReasonText = " your recent or previous loan conduct";
      declineReasonMeaning = "loan conduct";
      linkSuffix = "-recent-or-previous-conduct";
      break;
    case DECLINED_REASONS.OUTSIDE_OF_LENDING_CRITERIA:
    default:
      declinedReasonText = " being outside of our lending criteria";
      declineReasonMeaning = "our lending criteria";
      linkSuffix = "-being-outside-of-our-lending-criteria";
      break;
  }

  let intro = <h3>We're sorry it's not better news!</h3>;
  if (firstName && firstName !== "" && firstName !== null) {
    intro = <h3>{firstName}, we're sorry it's not better news!</h3>;
  }
  const informationLink =
    "https://www.fairgofinance.com.au/goforwardwithus" + linkSuffix;

  const fgfContent = (
    <p>
      {" "}
      At this moment your loan application has been unsuccessful due to
      <span className="declined-reason">{declinedReasonText}</span>. For a more
      detailed explanation as to what {declineReasonMeaning} means, how it is
      assessed and tips on how to improve your loan chances,{" "}
      <a href={informationLink} target="_blank" rel="noopener noreferrer">
        here is some information we hope you find useful.
      </a>
    </p>
  );

  return (
    <Wrapper>
      <img className="animated-gif-sad" src={cryFace} alt="we're sorry" />
      {intro}
      {declinePageContent.length > 0 ? <p>{declinePageContent}</p> : fgfContent}
    </Wrapper>
  );
};
